import { render, staticRenderFns } from "./verificationError.html?vue&type=template&id=aaabf3da&scoped=true&"
import script from "./verificationError.vue?vue&type=script&lang=js&"
export * from "./verificationError.vue?vue&type=script&lang=js&"
import style0 from "./verificationError.vue?vue&type=style&index=0&id=aaabf3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaabf3da",
  null
  
)

export default component.exports